import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'

export enum ShippingCustomsContentsEnum {
  gift = 'gift',
  merchandise = 'merchandise',
  returnedGoods = 'returned_goods',
  documents = 'documents',
  sample = 'sample',
  other = 'other',
}

export enum ShippingCustomsNonDeliveryEnum {
  returnToSender = 'return_to_sender',
  treatAsAbandoned = 'treat_as_abandoned',
}

@ObjectType()
@InputType('ShippingCustomsItemsInput')
export class ShippingCustomsItems extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  description: string

  @Field(() => String)
  @Prop({ type: String })
  sku: string

  @Field(() => String)
  @Prop({ type: String })
  sku_description: string

  @Field(() => String)
  @Prop({ type: String })
  harmonized_tariff_code: string

  @Field(() => Float)
  @Prop({ type: Number })
  value: number

  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number
}

@ObjectType()
@InputType('ShippingCustomsInput')
export class ShippingCustoms extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  contents: ShippingCustomsContentsEnum

  @Field(() => String)
  @Prop({ type: String })
  contentsExplanation: string

  @Field(() => String)
  @Prop({ type: String })
  nonDelivery: ShippingCustomsNonDeliveryEnum

  @Field(() => [ShippingCustomsItems])
  @Prop({ type: [ShippingCustomsItems] })
  items: ShippingCustomsItems[]

  @Field(() => String)
  @Prop({ type: String })
  declaration: string

  @Field(() => String)
  @Prop({ type: String })
  termsOfTradeCode: string
}
